const mediaItems = [
  {
    title: '《狂飙》高能名场面合集',
    desc: '张颂文饰演高启强的经典片段回顾，演技炸裂',
    duration: '15:32',
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20with%20two%20men%20in%20heated%20confrontation%20in%20a%20dimly%20lit%20office%2C%20dramatic%20cinematic%20lighting%2C%20smoke%20in%20the%20air%2C%20professional%20film%20grain%2C%20warm%20amber%20and%20dark%20tones%2C%20no%20text&width=640&height=360&seq=media-luobo-01&orientation=landscape'
  },
  {
    title: '《繁花》上海风情深度解析',
    desc: '王家卫镜头下的90年代上海，每一帧都是艺术',
    duration: '22:08',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20at%20night%20with%20colorful%20neon%20signs%20and%20vintage%20cars%2C%20wet%20asphalt%20reflecting%20city%20lights%2C%20nostalgic%20golden%20warm%20atmosphere%2C%20cinematic%20film%20aesthetic%2C%20no%20text&width=640&height=360&seq=media-luobo-02&orientation=landscape'
  },
  {
    title: '《漫长的季节》悬疑线梳理',
    desc: '豆瓣9.4分神作的时间线全解析，细节拉满',
    duration: '18:45',
    image: 'https://readdy.ai/api/search-image?query=Autumn%20train%20tracks%20winding%20through%20golden%20fields%20in%20northeast%20China%2C%20warm%20sunset%20light%20casting%20long%20shadows%2C%20nostalgic%20melancholic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20film%20grain%2C%20no%20text&width=640&height=360&seq=media-luobo-03&orientation=landscape'
  },
  {
    title: '《黑暗荣耀》复仇线复盘',
    desc: '宋慧乔饰演文东恩的复仇计划全回顾',
    duration: '20:15',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Korean%20drama%20scene%20with%20a%20woman%20in%20dark%20coat%20standing%20by%20large%20window%20overlooking%20city%20at%20night%2C%20cold%20blue%20tone%20contrasting%20with%20warm%20interior%20light%2C%20sophisticated%20cinematography%2C%20no%20text&width=640&height=360&seq=media-luobo-04&orientation=landscape'
  },
  {
    title: '《琅琊榜》经典台词回顾',
    desc: '胡歌饰演梅长苏最触动人心的名场面合集',
    duration: '12:50',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scholar%20in%20white%20robes%20standing%20in%20bamboo%20forest%20with%20mist%20and%20soft%20sunlight%20filtering%20through%2C%20ethereal%20atmosphere%2C%20ink%20wash%20painting%20aesthetic%2C%20peaceful%20contemplative%20mood%2C%20no%20text&width=640&height=360&seq=media-luobo-05&orientation=landscape'
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              精彩花絮
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              热门电视剧全集的高光时刻与深度解析，追剧之余的延伸内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className={`group bg-background-200/70 rounded-xl overflow-hidden border border-background-300/30 hover:border-primary-500/30 cursor-pointer transition-all duration-200 ${
                  i === 0 ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-200 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                      <i className="ri-play-fill text-foreground-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2.5 right-2.5 px-2 py-0.5 rounded-md bg-background-50/80 text-foreground-200 text-xs font-medium whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-foreground-100 text-sm font-medium mb-1.5">{item.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}